import React, { useEffect } from 'react';

const MesafeliSatisSozlesmesi = () => {
  useEffect(() => {
    document.title = 'Mesafeli Satış Sözleşmesi - Yaşasın Hamileyim';
  }, []);

  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '0 auto', 
      padding: '40px 20px',
      lineHeight: '1.8',
      color: '#333'
    }}>
      <h1 style={{ 
        fontSize: '2rem', 
        fontWeight: '700', 
        marginBottom: '30px',
        color: '#667eea',
        textAlign: 'center'
      }}>
        MESAFELİ SATIŞ SÖZLEŞMESİ
      </h1>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          1. TARAFLAR
        </h2>
        <p>
          Bu Mesafeli Satış Sözleşmesi, aşağıdaki taraflar arasında aşağıda belirtilen hüküm ve şartlar çerçevesinde imzalanmıştır.
        </p>
        <p style={{ marginTop: '10px' }}>
          <strong>SATICI:</strong><br />
          <strong>Ünvan:</strong> Gyneco Sağlık Hizmetleri Ticaret Limited Şirketi<br />
          <strong>Telefon:</strong> 0 (532) 775 76 16<br />
          <strong>E-posta:</strong> info@yasasinhamileyim.com
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>ALICI:</strong> Bu sözleşmeyi kabul eden ve sipariş veren gerçek veya tüzel kişi.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          2. KONU
        </h2>
        <p>
          Bu sözleşmenin konusu, ALICI'nın satın aldığı "Yaşasın Hamileyim Eğitimi" dijital eğitim paketinin, 
          aşağıdaki şartlar ve fiyat üzerinden SATICI tarafından ALICI'ya teslim edilmesi ve ALICI'nın 
          bu eğitimi kullanma hakkına sahip olmasıdır.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          3. SÖZLEŞME KONUSU ÜRÜN/HİZMET
        </h2>
        <p>
          <strong>Ürün/Hizmet Adı:</strong> Yaşasın Hamileyim Eğitimi<br />
          <strong>İçerik:</strong>
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>Ömür boyu sınırsız izleme hakkı</li>
          <li>Nefes Eğitimi</li>
          <li>Emzirme Eğitimi</li>
          <li>Doğum Hazırlık Eğitimi</li>
          <li>Bebek Bakımı Eğitimi</li>
          <li>Hamilelik Beslenme Eğitimi</li>
        </ul>
        <p style={{ marginTop: '15px' }}>
          <strong>Fiyat:</strong> 3.999 TL (KDV dahil)
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          4. GENEL HÜKÜMLER
        </h2>
        <p>
          4.1. ALICI, bu sözleşmede belirtilen ürün/hizmetin satış fiyatını, aşağıda belirtilen ödeme 
          yöntemlerinden birini seçerek ödemeyi kabul ve taahhüt eder.
        </p>
        <p style={{ marginTop: '10px' }}>
          4.2. ALICI, sipariş verdiği ürün/hizmetin teslimat bilgilerini doğru ve eksiksiz olarak 
          vermeyi kabul eder.
        </p>
        <p style={{ marginTop: '10px' }}>
          4.3. SATICI, ALICI'nın ödemesini onayladıktan sonra, eğitim içeriğine erişim bilgilerini 
          ALICI'nın kayıtlı e-posta adresine gönderir.
        </p>
        <p style={{ marginTop: '10px' }}>
          4.4. ALICI, eğitim içeriğine erişim için gerekli kullanıcı adı ve şifre bilgilerini 
          güvenli bir şekilde saklamakla yükümlüdür.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          5. ÖDEME
        </h2>
        <p>
          5.1. Ürün/hizmet bedeli, sipariş sırasında belirtilen fiyat üzerinden ödenir.
        </p>
        <p style={{ marginTop: '10px' }}>
          5.2. Ödeme yöntemleri: Kredi kartı, banka kartı veya banka havalesi ile ödeme yapılabilir.
        </p>
        <p style={{ marginTop: '10px' }}>
          5.3. Ödeme işlemi, Iyzico ödeme altyapısı üzerinden güvenli bir şekilde gerçekleştirilir.
        </p>
        <p style={{ marginTop: '10px' }}>
          5.4. Ödeme onayından sonra ALICI'ya fatura düzenlenir ve e-posta ile gönderilir.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          6. TESLİMAT
        </h2>
        <p>
          6.1. Dijital eğitim içeriği, ödeme onayından hemen sonra otomatik olarak ALICI'nın 
          hesabına aktarılır ve ALICI anında eğitim içeriğine erişim sağlayabilir.
        </p>
        <p style={{ marginTop: '10px' }}>
          6.2. ALICI, eğitim içeriğine ömür boyu erişim hakkına sahiptir.
        </p>
        <p style={{ marginTop: '10px' }}>
          6.3. Ödeme işlemi tamamlandıktan sonra, ALICI'nın hesabı otomatik olarak aktif hale 
          gelir ve eğitim içeriğine anında erişim sağlanır.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          7. CAYMA HAKKI
        </h2>
        <p>
          7.1. ALICI, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler 
          Yönetmeliği hükümlerine göre cayma hakkına sahiptir.
        </p>
        <p style={{ marginTop: '10px' }}>
          7.2. <strong>Cayma hakkı süresi:</strong> Ödeme tarihinden itibaren 7 (yedi) gün içinde 
          cayma hakkı kullanılabilir.
        </p>
        <p style={{ marginTop: '10px' }}>
          7.3. <strong>Cayma hakkının sona ermesi:</strong> Aşağıdaki durumlardan herhangi biri 
          gerçekleştiğinde cayma hakkı sona erer ve iade yapılamaz:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>Ödeme tarihinden itibaren 7 günün geçmesi</li>
          <li>Eğitim içeriğinin %10'unun izlenmesi</li>
        </ul>
        <p style={{ marginTop: '10px' }}>
          7.4. Cayma hakkının kullanılması durumunda, ödenen bedel 21 iş günü içinde ALICI'ya 
          iade edilir.
        </p>
        <p style={{ marginTop: '10px' }}>
          7.5. Cayma hakkını kullanmak için ALICI, SATICI'ya yazılı olarak (e-posta veya telefon) 
          bildirimde bulunmalıdır.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          8. HESAP PAYLAŞIMI VE ÜYELİK İPTALİ
        </h2>
        <p>
          8.1. ALICI, eğitim içeriğine erişim için oluşturulan hesabını ve erişim bilgilerini 
          gizli tutmakla yükümlüdür.
        </p>
        <p style={{ marginTop: '10px' }}>
          8.2. ALICI, hesabını ve erişim bilgilerini üçüncü kişilerle paylaşamaz, devredemez 
          veya başkalarının kullanımına açamaz.
        </p>
        <p style={{ marginTop: '10px' }}>
          8.3. ALICI'nın hesabını veya erişim bilgilerini SATICI'dan izinsiz olarak başkalarıyla 
          paylaştığının tespit edilmesi durumunda, SATICI üyeliği derhal iptal etme hakkına sahiptir.
        </p>
        <p style={{ marginTop: '10px' }}>
          8.4. Üyelik iptali durumunda, ALICI'nın eğitim içeriğine erişimi sona erer ve herhangi 
          bir iade yapılmaz.
        </p>
        <p style={{ marginTop: '10px' }}>
          8.5. Hesap paylaşımının tespiti, teknik izleme, kullanım analizi veya şikayet yoluyla 
          yapılabilir.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          9. FİKRİ MÜLKİYET HAKLARI
        </h2>
        <p>
          8.1. Eğitim içeriği ve tüm materyaller SATICI'ya aittir ve telif hakları korunmaktadır.
        </p>
        <p style={{ marginTop: '10px' }}>
          8.2. ALICI, eğitim içeriğini sadece kişisel kullanım amaçlı kullanabilir. İçeriğin 
          kopyalanması, çoğaltılması, dağıtılması veya ticari amaçla kullanılması yasaktır.
        </p>
        <p style={{ marginTop: '10px' }}>
          8.3. Bu hakların ihlali durumunda, SATICI yasal haklarını saklı tutar.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          10. SORUMLULUK SINIRLAMASI
        </h2>
        <p>
          9.1. Eğitim içeriği bilgilendirme amaçlıdır ve tıbbi tavsiye niteliği taşımaz.
        </p>
        <p style={{ marginTop: '10px' }}>
          9.2. ALICI, eğitim içeriğindeki bilgileri kullanırken kendi sorumluluğundadır ve 
          tıbbi kararlar için mutlaka bir sağlık uzmanına danışmalıdır.
        </p>
        <p style={{ marginTop: '10px' }}>
          9.3. SATICI, eğitim içeriğinin kullanımından kaynaklanan herhangi bir zarardan 
          sorumlu tutulamaz.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          11. UYUŞMAZLIKLARIN ÇÖZÜMÜ
        </h2>
        <p>
          10.1. Bu sözleşmeden kaynaklanan uyuşmazlıkların çözümünde Türkiye Cumhuriyeti 
          yasaları uygulanır.
        </p>
        <p style={{ marginTop: '10px' }}>
          10.2. Tüketici uyuşmazlıkları için Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri 
          yetkilidir.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          12. SÖZLEŞMENİN KABULÜ
        </h2>
        <p>
          ALICI, bu sözleşmeyi okuduğunu, anladığını ve kabul ettiğini, sipariş vermek suretiyle 
          beyan ve taahhüt eder.
        </p>
        <p style={{ marginTop: '15px', fontWeight: 'bold', fontSize: '1.1rem', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
          <strong>ÖNEMLİ:</strong> Ürünü satın alarak ödeme işlemini tamamladığınızda, bu Mesafeli 
          Satış Sözleşmesi'nin tüm hükümlerini okuduğunuzu, anladığınızı ve kabul ettiğinizi 
          beyan etmiş sayılırsınız. Sözleşme, ödeme işleminin tamamlanması ile birlikte taraflar 
          arasında geçerli hale gelir.
        </p>
      </div>

      <div style={{ 
        marginTop: '40px', 
        padding: '20px', 
        backgroundColor: '#f5f7fa', 
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
          <strong>Son Güncelleme:</strong> {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>
    </div>
  );
};

export default MesafeliSatisSozlesmesi;


